export default "__VITE_ASSET__BlZ0mlmY__"